module.exports = __webpack_public_path__ + "img/Checkmark-orange.1a448af1.svg";